import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/FinancePageLayout";
import { ActionButtons, CTAButtons, SupportButtons } from "../../../../global/components/Buttons/buttons";
import Table from "../../../Components/Table/Table";
import {
  SearchFilter,
  ActionButton,
  CalendarFilter2,
  ProDropFilter,
} from "../../../Components/Search/Search";
import Pagination from "../../../Components/Pagination/Pagination";
import { useNavigate } from "react-router";
import { URL } from "../../../../../utils/routes";
import { useDispatch, useSelector } from "react-redux";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { TableActions } from "../../../Components/Misc/ActionsModVersion";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import { FilterButton } from "../../../Components/Search/Search";
import './style.css'
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { FiChevronDown, FiDelete, FiEdit2, FiEdit3, FiEye, FiTrash, FiUser, FiUsers } from "react-icons/fi";
import { AppModalTemplate } from "../../../Components/Modals/Modals";
import { FileUploadAlt } from "../../../Components/Forms/InputTemplate";
import { DeleteKeywords, GetKeywords, PreviewKeywordBatchThunk, UploadKeywordBatchThunk, setEditMode, viewKeyword } from "../../../../../utils/redux/Finance/AnalyseCompanyFund/AnalyseCompanyFundSlice";
import { IoAddSharp } from "react-icons/io5";
import { toast } from "react-toastify";

function Keywords() {
  // Filter states
  const [optionOpen, setOptionOpen] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [filters, setFilters] = useState([]);
  const [search, setSearch] = useState("");
  const [position, setPosition] = useState('');
  // const [endDate, setEndDate] = useState();
  // const [startDate, setStartDate] = useState();
  const [pageSize, setPageSize] = useState(5);
  const [pageNumber, setPageNumber] = useState(1);

  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);


  const navigate = useNavigate();
  const dispatch = useDispatch();

  /**Data Fetching */
  let { Keywords } = useSelector(state=> state.companyFund);

  useEffect(() => {
    dispatch(GetKeywords({PageSize: pageSize, PageNumber: pageNumber, Search: search, Position: position}))
  }, [pageNumber, pageSize, search, filters, position, dispatch]);

  const actionButton = (
    <>
      <CTAButtons onClick={() => {dispatch(setEditMode(false)); navigate("../SetupKeyword")}}>
        Create Keyword
      </CTAButtons>
    </>
  );

  const altActionButton = (
    <button className="altActionButton" onClick={() => {setModalOpen(true)}}>
      <IoAddSharp size={22} className="mr-1" />
      <p>Batch Creation of Keywords</p>
    </button>
  );

  // Filter options to Map in Filter Modal
  // When Selected, it uses the corresponding key in the mapped data and filters by the selected option
  const filterBy = [
    {
      key: "positions",
      options: ["Front-end Engineer", "Developer"]
    },
    {
      key: "departments",
      options: ["Information Technology IT", "Human Resources"]
    },
  ];
  
  let mockData = Keywords?.result?.filter(r=> r.name.includes(search))?.map((item)=> ({
    ...item,
    id: item.id,
    date: item.createdDate?.split("T")[0],
    name: item.name,
    accountNumber: item.accountNumber,
    accountName: item.accountName,
    position: item.position===0?"debit": item.position===1?"credit": null,
  }));
  let currentHeaders = [
    {
      title: "Date",
      key: "date",
    },
    {
      title: "Name",
      key: "name",
    },
    {
      title: "Position",
      key: "position",
    },
    {
      title: "Account Number",
      key: "accountNumber",
    },
    {
      title: "Account Name",
      key: "accountName",
    },
    {
      title: "Actions",
      key: null,
    },
    
  ];
  
  // Format for "More Options" buttons:
  let mockRowOptions = [
    // {name: "View", icon: <FiEye />, action: (item)=> { console.log({item}); /*navigate(`${item.id}/view`)*/}},
    {name: "Edit", icon: <FiEdit2 color="#946300" />, action: (rowData)=> { dispatch(viewKeyword(rowData)); dispatch(setEditMode(true)); navigate("../SetupKeyword"); }},
    {name: "Disable", icon: <FiTrash color="#E61B00" />, action: (rowData)=> { dispatch(DeleteKeywords({id: rowData.id})).then(()=> setTimeout(()=> dispatch(GetKeywords({PageSize: pageSize, PageNumber: pageNumber, Search: search, Position: position})), 1000) ) }},
  ];

  async function uploadKeywordBatch(){
    setIsLoading(true);
    let formData = new FormData();
    formData.append("File", file);
    
    // Get File preview
    dispatch(PreviewKeywordBatchThunk(formData))
    .then(response=> {
      setIsLoading(false);
      console.log({response});
      // toast error if file is empty
      if(!response.payload) {
        return toast.error("File is empty!")
      }
      // Loop through preview array for already existing keywords
      let validEntries = response?.payload?.filter(r=> !r.comment);
      let filesRemoved = response?.payload?.length - validEntries?.length || 0;
      if (validEntries?.length) {
        dispatch(UploadKeywordBatchThunk({ treasuryKeyword: validEntries }));
      }
    })
  }

  return (
    <RouteLayout title={"Finance"}>
      <PageStyle
        title={"Keywords"}
        hasBack={false}
        action={[altActionButton, actionButton]}
        isMain={true}
      >
        <div className={DashboardStyle.dashboard_filter}>
          <SearchFilter text={setSearch} />
          <div className="text-green-800">
            <p>Position</p>
            <select onChange={({target})=> setPosition(target.value)} defaultValue={position} className="rounded border border-[#D9E9DA] h-[40px] focus:outline-green-800">
              <option value={0}>Debit</option>
              <option value={1}>Credit</option>
            </select>
          </div>
          <FilterButton onSubmit={()=> {}} onClick={() => setFilterModal(prev=> !prev)} name="" />
        </div>
        <div className={DashboardStyle.dashboard_table_holder}>
          <Table>
            <thead>
              <tr>
              {
                currentHeaders.map((header, i)=> <th className={`!text-[#29382A] ${header.title==='Actions' && "flex justify-end !pr-6"}`} key={i}>{header.title}</th>)
              }
              </tr>
            </thead>
            <tbody>
              <RequestTable
                isLoading={false}
                data={mockData}
                keys={currentHeaders.map(header=> header.key)}
                selectable={false}
                rowOptions={mockRowOptions}
              />
            </tbody>
          </Table>
        </div>
        <Pagination
          last_page={Keywords?.totalPages}
          present_page={Keywords?.currentPage || pageNumber}
          totalRows={(Keywords?.result?.length < pageSize) && pageNumber === 1? Keywords.result.length : Keywords?.totalRows || 0}
          pageSize={(Keywords?.result?.length < pageSize)?  Keywords.result.length : Keywords?.pageSize || 0}
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setPageNumber(page)}
        />
      </PageStyle>


      <AppModalTemplate 
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        hasCancel={true}
        closeFunction={()=> setModalOpen(false)}
      >
        <div>
          <h1 className="text-[22px] text-[#4B664C]">Create Batch Keywords</h1>
          <p className="text-[12px] text-[#29382A]">Upload your bulk product file here</p>
        </div>
        <div className="my-6">
          <FileUploadAlt
          file={file}
          setFile={setFile}
          fileTypes={["XLSX"]}
          title={""}
          />
        </div>
        <div>
          <p className="my-5 text-center text-[12px] text-[#767171]" >Download Bulk creation template <a download href={"/keywords.xlsx"} className="underline text-[12px] text-[#305F32]">here</a></p>
        </div>
        <div className="flex w-full justify-between mt-8">
          <SupportButtons
            onClick={() => setModalOpen(false)}
            width={"auto"}
            className={DashboardStyle?.button_cage_weight}
          >
            Cancel
          </SupportButtons>
          <ActionButtons
            isLoading={isLoading}
            onClick={uploadKeywordBatch}
            // disabled={!isValid}
            width={"auto"}
            className={DashboardStyle?.button_cage_weight}
          >
            Submit
          </ActionButtons>
        </div>
      </AppModalTemplate>
    </RouteLayout>
  );
}

export default Keywords;

function RequestTable({
  data,
  keys,
  selectable,
  HandleSelectedItems,
  selectedItems,
  rowOptions,
}) {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // console.log({data, keys})
  return (
    <>
      {data?.map((item) => (
        <tr key={item.id}>
           {selectable && ( 
            <td>
              <input
                type="checkbox"
                checked={selectedItems.includes(item.id)}
                onChange={(e) => HandleSelectedItems(item.id, e.target.checked)}
                style={{ height: "20px", width: "20px" }}
              />
            </td>)}
          {
            keys.filter(key=> key).map((key, i) => (<td key={i}>{item[key]}</td>))
          }
          
          <td>
            <div className={`flex justify-end bg-transparent`}>
            <TableActions rowData={item} children={rowOptions}>
              {rowOptions}
            </TableActions>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
}
